import React, { useState, useRef } from "react";
import emailjs from '@emailjs/browser';

const ContactRight = () => {
  const form = useRef();
  //====== Email validation ========
  const emailValidation = () => {
    return String(email)
      .toLocaleLowerCase()
      .match(/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/);
    //========Email validation=======
  };
  const [username, setUsername] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setemail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const sendMessage = (e) => {
    e.preventDefault();
    emailjs.sendForm('service_26wwg2d', 'template_9mzg9ty', form.current, 'user_8KK7cHeHBZLjhs6xeLZMq')
    .then(() => {
      if (username === "") {
        setErrMsg("Username is required!");
      } else if (phoneNumber === "") {
        setErrMsg("Phone number is required!");
      } else if (email === "") {
        setErrMsg("Email is required!");
      } else if (!emailValidation(email)) {
        setErrMsg("Enter valid email!");
      } else if (subject === "") {
        setErrMsg("Subject is required!");
      } else if (message === "") {
        setErrMsg("Message is required!");
      } else {
        setSuccessMsg(`Thank you ${username}, Your message has been sent Successfully!`);
        setErrMsg("");
        setUsername("");
        setPhoneNumber("");
        setemail("");
        setSubject("");
        setMessage("");
      }
    }, (error) => {
        console.log(error.text);
    });
   
  };
  return (
    <div
      className="w-full lgl:w-[60%] h-full py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b]
           flex flex-col gap-8 p-4 lgl:p-8 rounded-lg shadow-shadowOne "
    >
      <form ref={form} onSubmit={sendMessage}
      className="w-full flex flex-col gap-4 lgl:gap-6 py-2 lgl:py-2">
        {errMsg && (
          <p
            className="py-3 bg-gradient-to-r from-[#1e2924] to-[#23272b]
            shadow-shadowOne text-center text-orange-500 text-base tracking-wide
            animate-bounce "
          >
            {errMsg}
          </p>
        )}
        {successMsg && (
          <p
            className="py-3 bg-gradient-to-r from-[#1e2024] to-[#23272b]
            shadow-shadowOne text-center text-green-500 text-base tracking-wide
            animate-bounce "
          >
            {successMsg}
          </p>
        )}
        <div className="w-full flex flex-col lgl:flex-row gap-10">
          <div className="w-full lgl:w-1/2 flex flex-col gap-4">
            <p className="text-sm text-gray-400 uppercase tracking-wide">
              YOUR NAME
            </p>
            <input
              onChange={(e) => setUsername(e.target.value)}
              value={username}
              className={`${
                errMsg === "Username is required!" && "outline-designColor"
              } contactInput`}
              type="text" name="user_name"
            />
          </div>
          <div className="w-full lgl:w-1/2 flex flex-col gap-4">
            <p className="text-sm text-gray-400 uppercase tracking-wide">
              Phone Number
            </p>
            <input
              onChange={(e) => setPhoneNumber(e.target.value)}
              value={phoneNumber}
              className={`${
                errMsg === "Phone number is required!" && "outline-designColor"
              } contactInput`}
              type="text"
              name="user_phone"
            />
          </div>
        </div>
        <div className="flex flex-col gap-4 ">
          <p className="text-sm text-gray-400 uppercase tracking-wide">Email</p>
          <input
            onChange={(e) => setemail(e.target.value)}
            value={email}
            className={`${
                errMsg === "Email is required!" && "outline-designColor"
              } contactInput`}
            type="email"
            name="user_email"
          />
        </div>
        <div className="flex flex-col gap-4 ">
          <p className="text-sm text-gray-400 uppercase tracking-wide">
            Subject
          </p>
          <input
            onChange={(e) => setSubject(e.target.value)}
            value={subject}
            className={`${
                errMsg === "Subject is required!" && "outline-designColor"
              } contactInput`}
            type="text"
            name="subject"
          />
        </div>
        <div className="flex flex-col gap-4 ">
          <p className="text-sm text-gray-400 uppercase tracking-wide">
            Message
          </p>

          <textarea
            onChange={(e) => setMessage(e.target.value)}
            value={message}
            className={`${
                errMsg === "Message is required!" && "outline-designColor"
              } contactTextArea`}
            
            cols="30"
            rows="8"
            name="message"
          ></textarea>
        </div>
        <div className="w-full">
          <button
            onClick={sendMessage}
            className="w-full h-12 bg-[#141518] rounded-lg text-base border-b-gray-600 bg-[#191b1e]
                      text-gray-400 tracking-wider uppercase hover:text-white duration-300 hover:border-[1px] 
                     hover:border-designColor border-transparent"
          >
            Send Message
          </button>
        </div>
        {errMsg && (
          <p
            className="py-3 bg-gradient-to-r from-[#1e2924] to-[#23272b]
            shadow-shadowOne text-center text-orange-500 text-base tracking-wide
            animate-bounce "
          >
            {errMsg}
          </p>
        )}
        {successMsg && (
          <p
            className="py-3 bg-gradient-to-r from-[#1e2024] to-[#23272b]
            shadow-shadowOne text-center text-green-500 text-base tracking-wide
            animate-bounce "
          >
            {successMsg}
          </p>
        )}
      </form>
    </div>
  );
};

export default ContactRight;
